
//inViewチェック
const isInView = (target, anchor = 0.5, rate = 1) =>
{
  //スクロール量
  const scrollY = $(window).scrollTop()

  //ウィンドウの高さ
  const windowH = $(window).outerHeight()

  //ターゲット座標
  const targetY = (target.offset().top - scrollY) +  target.outerHeight() * anchor

  return (targetY <= windowH * rate)
}

//表示されているかどうかの判定
const isVisible = (target, offsetTop = 10, offsetBottom = 10) =>
{
  //スクロール量
  const scrollY = $(window).scrollTop()

  //ウィンドウの高さ
  const windowH = $(window).outerHeight()

  //ターゲット座標
  let targetTop = target.offset().top - scrollY
  let targetBottom = targetTop + target.outerHeight()

  //オフセット
  targetTop += offsetTop
  targetBottom -= offsetBottom

  return !(targetTop > windowH || targetBottom < 0)
}


const ScrollUtil = {
  isInView: isInView,
  isVisible: isVisible
}
export default ScrollUtil